import { Text, Container } from 'pixi.js'
import { Text as TextEntity } from "../../entity/text/Text";
import { containerEvents } from "../../ContainerEvents";

export class TextPlaceholder {

    constructor(label) {
        this.label = label;
        this.setup();
    }

    setup() {
        if (this.text) this.text.destroy();
        const graphicItem = new Text(this.label);
        let container = new Container();
        container.x = containerEvents.mouseCoords.x - (graphicItem.width / 2);
        container.y = containerEvents.mouseCoords.y - (graphicItem.height / 2);
        this.text = new TextEntity({container, graphicItem});
        this.text.draw();
    }

    getStatement() {
        return this.text;
    }

    follow(position) {
        this.text.container.x = position.x - (this.text.container.width / 2);
        this.text.container.y = position.y - (this.text.container.height / 2);
    }

    destroy() {
        this.text.destroy();
    }
}